import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailDrip,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const Base: IFeatureMap = {
  data: {
    includedKnownPeople: 20000,
    // 100x Known People
    includedAnonymousPeople: 100 * 20000,
    // 100k Known People actions (monthly)
    trackedActivities: 100000,
    // 10k Known People (monthly)
    emailsSent: 10000,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 20,
    conversionPixels: 10,
    implementationsPageVisible: true,
    zapier: Infinity,
    directIntegrations: 0,
    iMISDirectIntegration: false,
    blackbaudDirectIntegration: false,
  },
  ads: {
    [retargeting]: true,
    // 5 published/active (monthly)
    [mobileGeoFencing]: 5,
    // 5 published/active (monthly)
    [mobileGeoFenceRetargeting]: 5,
    [facebook]: true,
    [emailListFacebook]: true,
    // 5 published/active (monthly)
    [emailList]: 5,
    [search]: true,
    [seedSegment]: true,
    [affinity]: true,
    [googleAdsSmart]: true,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: true,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    [mailrailDrip]: true,
    domainsAuthenticated: 3,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    // 10/month
    adBannerCreator: 10,
  },
  invites: {
    [invites]: true,
    partnerManager: true,
    partnersPerProject: 0,
    partnerMarketingCollateralBuilder: true,
    partnerDashboards: 25,
  },
  monetization: {
    sponsoredRetargetingCampaigns: true,
    liveSponsorReports: true,
  },
  other: {
    flights: true,
    forms: true,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: 10,
    users: 0,
    childAccountsWithSwitcher: 0,
    childAccountSharingWithPermissionManagement: 0,
    customUserRolesAndPermissionsManagement: false,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: 3,
    livePhoneSupport: true,
    dataIntegrationServicesActiveWithLicense: true,
    proResourcesPageVisible: true,
  },
};
